import { getDynamicRoute } from "util/createProfileIdPath";
import getLogger from "../../logger/index";
import { get } from "util/apiRequest";

const log = getLogger("PARSER_REQUEST");
export const SEARCH_REQUEST = "SEARCH_REQUEST";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";
export const SEARCH_FAILURE = "SEARCH_FAILURE";
export const REQUESTING = "Requesting";
export const SUCCESS = "Success";
export const ERROR = "Error";

export function searchRequest() {
  return {
    type: SEARCH_REQUEST,
    status: REQUESTING,
  };
}
export function searchSuccess(agents) {
  return {
    type: SEARCH_SUCCESS,
    status: SUCCESS,
    agents,
  };
}
export function searchFailure(error) {
  return {
    type: SEARCH_FAILURE,
    status: ERROR,
    error,
  };
}

export function search(
  city,
  state_code,
  name,
  selectedType,
  postalCode,
  certificationResult,
  filtervalues,
  seoUserType,
  location,
  county,
  is_county_search,
  isGoogleBot,
) {
  const selectedTypeLowerCase = selectedType && selectedType.toLowerCase();
  const rating = filtervalues.rating;
  const recommendation = filtervalues.recommendation;
  const minPrice = filtervalues.minPrice;
  const maxPrice = filtervalues.maxPrice;
  const rep = filtervalues.rep;
  const photo = filtervalues.photo == undefined ? true : filtervalues.photo;
  const lang = filtervalues.lang;
  const sort = filtervalues.sort;
  const offset = filtervalues.offset;
  const whichPage = filtervalues.whichPage;
  const limit = whichPage == "list" || whichPage == undefined ? 20 : 100;

  return async (dispatch) => {
    dispatch(searchRequest());
    try {
      let url;

      url = `/${getDynamicRoute()}/api/v3/search?nar_only=1&offset=${offset}&limit=${limit}&marketing_area_cities=${location}&postal_code=${postalCode}&is_postal_search=true&name=${name}&types=${selectedTypeLowerCase}&sort=${sort}&far_opt_out=false&client_id=FAR2.0&recommendations_count_min=${recommendation}&agent_rating_min=${rating}&languages=${lang}&agent_type=${rep}&price_min=${minPrice}&price_max=${maxPrice}&designations=${certificationResult}&photo=${photo}&seoUserType=${seoUserType}&is_county_search=${is_county_search}&county=${county}&isGoogleBot=${isGoogleBot}`;

      const result = await get(url, 5000);

      const resultJson = result;

      if (resultJson.error) {
        throw new Error(resultJson.error);
      }
      return dispatch(searchSuccess(resultJson.data));
    } catch (e) {
      log.error("Error while fetching SEARCH_REQUEST data", e);
      dispatch(searchFailure(e.message));
    }
  };
}
